import React from 'react';
import classNames from 'classnames';
import {Icon, Link, Collapsible} from '@shopify/polaris';
import {withI18n, WithI18nProps} from '@shopify/react-i18n';
import {TaxonomyNode} from 'sections/types';
import {
  Routes,
  fetchTaxonomy,
  sendGoogleAnalytics,
} from 'sections/services-marketplace/experts/utilities';
import {Heading} from 'sections/services-marketplace/experts/components';
import {
  GoogleAnalyticsEventActions,
  GoogleAnalyticsEventType,
} from '../../utilities/constants';

import styles from './NavigationMobile.scss';

interface OwnProps {
  list: TaxonomyNode[];
  onSelectItem(): void;
}

type CombinedProps = WithI18nProps & OwnProps;

function ServiceItems({list, onSelectItem, i18n}: CombinedProps) {
  return (
    <>
      <Heading>
        {i18n.translate('Global.MobileNavigation.browseCategoriesTitle')}
      </Heading>
      <ul className={styles.List}>
        {list.map(item => (
          <Item
            item={item}
            onSelectItem={onSelectItem}
            key={item.service.handle}
          />
        ))}
      </ul>
    </>
  );
}

interface ItemState {
  expanded: boolean;
}

interface ItemProps {
  item: TaxonomyNode;
  onSelectItem?(): void;
}

class Item extends React.PureComponent<ItemProps, ItemState> {
  state: ItemState = {
    expanded: false,
  };

  taxonomy = fetchTaxonomy();

  onServiceClick = () => {
    const {onSelectItem, item} = this.props;
    if (onSelectItem) {
      onSelectItem();
    }
    sendGoogleAnalytics({
      type: GoogleAnalyticsEventType.Event,
      payload: {
        eventAction: GoogleAnalyticsEventActions.navigationClick,
        eventLabel: item.service.handle,
      },
    });
  };

  render() {
    const {item} = this.props;
    return (
      <li className={styles.ListItem}>
        {item.children && item.children.length ? (
          this.renderWithChildren(item)
        ) : (
          <div className={styles.ListItemLink}>
            <Link
              url={Routes.servicePath(this.taxonomy, item.service.handle)}
              onClick={this.onServiceClick}
            >
              {item.service.shortLabel}
            </Link>
          </div>
        )}
      </li>
    );
  }

  renderWithChildren(item: TaxonomyNode) {
    const {onSelectItem} = this.props;
    const {expanded} = this.state;

    return (
      <>
        <div className={styles.ListItemLink}>
          <button
            onClick={this.toggleChildren}
            className={styles.ListItemLink}
            aria-controls={item.service.handle}
            aria-expanded={expanded}
            type="button"
          >
            <span className={styles.ListItemLinkText}>
              {item.service.shortLabel}
            </span>
            <span className={classNames(expanded && styles.IconExpanded)}>
              <Icon source="chevronDown" color="inkLightest" />
            </span>
          </button>
        </div>
        <Collapsible open={expanded} id={item.service.handle}>
          <div className={styles.ChildListContainer}>
            <ul
              id={item.service.handle}
              className={styles.ChildList}
              aria-hidden={!expanded}
            >
              {item.children.map(childItem => (
                <Item
                  item={childItem}
                  key={childItem.service.handle}
                  onSelectItem={onSelectItem}
                />
              ))}
            </ul>
          </div>
        </Collapsible>
      </>
    );
  }

  toggleChildren = () => {
    this.setState(({expanded}) => ({expanded: !expanded}));
  };
}

export default withI18n()(ServiceItems);
